const LANG = {
  'en': {
    'Tutti': 'All',
    'Cerca un prodotto': 'Search for a product',
    'Altro': 'Other',
    'Ingredienti e allergeni' : 'Ingredients and allergens',
  },
}

export const translate = (key) => {
  const lang = navigator.language.split('-')[0] || 'it'
  return (LANG[lang] && LANG[lang][key]) || key
}
